export const NameSpace = "namespace"
export const CopyValue = "copyvalue"
export const Eng ="eng"
export const EngPro = "default"
export const EditPadText ="editpadtext"
export const EditPadIdx = "editpadidx"
export const SearchWordConst = "searchword"

